function mapWithConcurrency<T, R>(
  items: T[],
  concurrency: number,
  mapper: (item: T) => Promise<R>,
): Promise<R[]> {
  return new Promise((resolve, reject) => {
    if (items.length === 0) {
      resolve([]);
      return;
    }

    const results: R[] = new Array(items.length);
    let nextIndex = 0;
    let completed = 0;
    let hasFailed = false;

    function runNext(): void {
      if (hasFailed) {
        return;
      }
      const currentIndex = nextIndex;
      nextIndex += 1;
      if (currentIndex >= items.length) {
        return;
      }
      mapper(items[currentIndex])
        .then((result) => {
          results[currentIndex] = result;
          completed += 1;
          if (completed === items.length) {
            resolve(results);
          } else {
            runNext();
          }
        })
        .catch((error) => {
          hasFailed = true;
          reject(error);
        });
    }

    for (let i = 0; i < Math.min(concurrency, items.length); i += 1) {
      runNext();
    }
  });
}

export { mapWithConcurrency };
